import React, { useRef, useEffect, useMemo } from 'react'
import cn from 'classnames'
import { getElementScrollPosition, scrollToElementLeftRight } from '../utils/search'
import styles from './CategoryPill.module.scss'
import { ButtonBase } from '@material-ui/core'
import { bridge_getDeviceModel } from '../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { RESOURCE_RESTRAINED_HARDWARE } from '../VNMode/Utils'

const CategoryPill = ({ className, category, selectedCategory, setCategory }) => {
  const classNames = cn(styles.CategoryPill, className)
  const categoryPillRef = useRef()
  // TODO: [T38895] remove this when category navigation is redone
  const isResourceRestrained = useMemo(() => RESOURCE_RESTRAINED_HARDWARE?.includes(bridge_getDeviceModel()), [])

  const style = {}
  if (category.itemCategoryUuid === selectedCategory.id && selectedCategory.highlight) {
    style.backgroundColor = category.color
    style.color = '#ffffff'
    style.zIndex = '6'
  }

  useEffect(() => {
    if (isResourceRestrained) return

    if (categoryPillRef.current && category.itemCategoryUuid === selectedCategory.id) {
      scrollToElementLeftRight(categoryPillRef.current)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory.id])

  const handleClick = () => {
    setCategory(category.itemCategoryUuid)

    if (isResourceRestrained) {
      // direct scroll to category
      const el = document.querySelector(`[data-id="${category.itemCategoryUuid}"]`)

      // in the event that the item does not have a categoryId assigned, but category exists as categoryPill
      if (!el) return

      const parent = el.parentElement.parentElement
      const scrollValue = getElementScrollPosition(el) - 100
      parent.scroll({ top: scrollValue, left: 0, behavior: 'smooth' })
    }
  }

  return (
    <ButtonBase component="div" className={classNames} ref={categoryPillRef} style={style} onClick={handleClick}>
      <div className={styles.content}>{category.name}</div>
    </ButtonBase>
  )
}

export default CategoryPill
